import { Badge } from "@/components/ui/badge.tsx";
import { cn } from "@/lib/utils.ts";
import { formatRoleLabel } from "@/lib/utils/role-label";

interface RoleBadgeProps {
  /** RBAC role name (e.g. `"mentor"`, `"supervisor"`). */
  role: string | null | undefined;
  size?: "sm" | "md";
}

const COLORS: Record<string, string> = {
  mentee:
    "border-solid-1 rounded-sm border border-red-600 bg-red-50 text-red-900 hover:bg-red-300",
  mentor:
    "rounded-sm border-solid border-violet-700 bg-violet-50 text-violet-900 hover:bg-violet-300",
  lead_mentor:
    "rounded-sm border-solid border-indigo-700 bg-indigo-50 text-indigo-900 hover:bg-indigo-300",
  supervisor:
    "rounded-sm border-solid border-lime-600 bg-lime-50 text-lime-900 hover:bg-lime-500",
  admin: "rounded-sm bg-violet-500 text-zinc-700 hover:bg-violet-500",
  superadmin:
    "rounded-sm border border-orange-500 bg-orange-100 text-orange-600 hover:bg-orange-200",
};

export function RoleBadge({ role, size }: RoleBadgeProps) {
  if (!role) return null;
  const normalized = role.toLowerCase();
  const colors = COLORS[normalized];
  if (!colors) return null;

  const sizeClass = size === "sm" ? "px-2 py-0 text-xs" : "px-3 py-1 text-sm";
  const label = formatRoleLabel(normalized);
  if (!label) return null;

  return <Badge className={cn(colors, sizeClass)}>{label}</Badge>;
}
